import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import './CategoryProductPopup.css';

function CategoryProductPopup(props) {
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [mainImg, setMainImg] = useState("");
  const [pkgs, setPkgs] = useState([]);

  useEffect(() => {
    if (props?.images && props.images.length > 0) {
      const firstImg = props.images[0].image;
      setMainImg(getCleanImagePath(firstImg));
    } else {
      setMainImg("");
    }
    setPaginationIndex(0);
  }, [props.images]);

  useEffect(() => {
    let propPkgs = [];
    if (props?.pkgs && props?.pkgs.length > 0) {
      for (const pkg of props?.pkgs) {
        if (pkg.status === "APPROVED") {
          pkg["packageWidthFront"] = (pkg.packageWidth / 30.48).toFixed(2);
          pkg["packageHeightFront"] = (pkg.packageHeight / 30.48).toFixed(2);
          pkg["packageLengthFront"] = (pkg.packageLength / 30.48).toFixed(2);
          propPkgs.push(pkg);
        }
      }
    }
    setPkgs(propPkgs);
  }, [props.pkgs]);

  function getCleanImagePath(imagePath) {
    if (!imagePath) return "";
    if (imagePath.startsWith("products") || imagePath.startsWith("mob")) {
      return imagePath;
    }
    return imagePath.substr(41);
  }

  function scroll(spcl) {
    var doc = document.getElementById("category_popup_img_list_box_cntn_id");
    if (spcl === "l") {
      doc.scrollLeft -= 200;
    } else {
      doc.scrollLeft += 200;
    }
  }

  function changeImage(item, index) {
    setMainImg(getCleanImagePath(item.image));
    setPaginationIndex(index);
  }

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <div className="category-popup-overlay" onClick={handleClose}>
      <div className="category-popup-container" onClick={(e) => e.stopPropagation()}>
        <div className="category-popup-header">
          <div className="category-popup-title">Product Details</div>
          <button className="category-popup-close" onClick={handleClose}>
            &times;
          </button>
        </div>

        <div className="category-popup-content">
          <div className="category-popup-body">
            {/* Left Side - Images (fixed, no scroll) */}
            <div className="category-popup-left">
              <div className="category-popup-main-image">
                {props.images && props.images.length > 0 && mainImg ? (
                  <>
                    <img
                      src={`https://s3.toolsvilla.com/${mainImg}`}
                      alt="Product"
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                    <div className="category-popup-pagination-dots">
                      {props.images.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => changeImage(item, index)}
                          className={`category-popup-dot ${paginationIndex === index ? 'active' : ''}`}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="category-popup-no-image">No Image Available</div>
                )}
              </div>

              {/* Thumbnails */}
              <div className="category-popup-thumbnails">
                {props.images && props.images.length > 3 && (
                  <img
                    src="/left-slide-icon.webp"
                    className="category-popup-slider-icon"
                    alt="Previous"
                    onClick={() => scroll("l")}
                  />
                )}
                <div
                  className="category-popup-thumbnail-container"
                  id="category_popup_img_list_box_cntn_id"
                >
                  {props.images?.map((item, index) => (
                    <div
                      key={index}
                      className={`category-popup-thumbnail ${paginationIndex === index ? 'active' : ''}`}
                      onClick={() => changeImage(item, index)}
                    >
                      <img
                        src={`https://s3.toolsvilla.com/${getCleanImagePath(item.image)}`}
                        alt={`Thumbnail ${index + 1}`}
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    </div>
                  ))}
                </div>
                {props.images && props.images.length > 3 && (
                  <img
                    src="/right-slide-icon.webp"
                    className="category-popup-slider-icon"
                    alt="Next"
                    onClick={() => scroll("r")}
                  />
                )}
              </div>
            </div>

            {/* Right Side - Scrollable Details */}
            <div className="category-popup-right">
              <h2 className="category-popup-product-name">{props.name}</h2>
              {props.SKU && <div className="category-popup-sku">SKU: {props.SKU}</div>}
              {props.manufacturerName && (
                <div className="category-popup-manufacturer">
                  Brand: <strong>{props.manufacturerName}</strong>
                </div>
              )}

              <div className="category-popup-divider" />

              {/* Package Details */}
              {/*pkgs && pkgs.length > 0 && (
                <div className="category-popup-section">
                  <div className="category-popup-section-title">Package Details</div>
                  <div className="category-popup-package-table">
                    <table>
                      <thead>
                        <tr>
                          <th>Package</th>
                          <th>Name</th>
                          <th>Actual Weight (Kg)</th>
                          <th>After Packaging (Kg)</th>
                          <th>Dimensions (L×W×H Ft)</th>
                          <th>
                            Volumetric Weight
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>
                                  <p>(L×B×H)/5000</p>
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle ms-1"></i>
                            </OverlayTrigger>
                            (Kg)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pkgs.map((item, index) => (
                          <tr key={index}>
                            <td>Package {index + 1}</td>
                            <td><strong>{item.productName}</strong></td>
                            <td>{item.actualWeight}</td>
                            <td>{item.weight}</td>
                            <td>
                              {item.packageLengthFront} × {item.packageWidthFront} × {item.packageHeightFront}
                            </td>
                            <td><strong>{item?.vWeight?.toFixed(2)}</strong></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="category-popup-divider" />
                </div>
              )*/}

              {/* Short Description */}
              {props.sdescription && (
                <div className="category-popup-section">
                  <div className="category-popup-section-title">Short Description</div>
                  <div
                    className="category-popup-section-content"
                    dangerouslySetInnerHTML={{ __html: props.sdescription }}
                  />
                </div>
              )}

              {/* Description */}
              {props.description && (
                <div className="category-popup-section">
                  <div className="category-popup-section-title">Product Details</div>
                  <div
                    className="category-popup-section-content"
                    dangerouslySetInnerHTML={{ __html: props.description }}
                  />
                </div>
              )}

              {/* Additional Descriptions */}
              {props.descriptionNew?.map((item, index) => (
                <div key={index} className="category-popup-section">
                  <div className="category-popup-section-title">{item?.title}</div>
                  <div
                    className="category-popup-section-content"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                  {item?.title === 'Specification' && props?.specificationNew?.length > 0 && (
                    <ul className="category-popup-spec-list">
                      {props.specificationNew.map((spec, idx) => (
                        <li key={idx}>
                          {spec?.type?.name}: {spec?.name} {spec?.unit}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {/* Specifications (if not already shown) */}
              {!(props?.descriptionNew || []).some(
                obj => obj.title === "Specifications" || obj.title === "Specification"
              ) && props?.specificationNew?.length > 0 && (
                <div className="category-popup-section">
                  <div className="category-popup-section-title">Specifications</div>
                  <ul className="category-popup-spec-list">
                    {props.specificationNew.map((item, index) => (
                      <li key={index}>
                        {item?.type?.name}: {item?.name} {item?.unit}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryProductPopup;